import React from "react";
import { Grid } from "basis";
import {
  Container,
  Header,
  PortalBackground,
  TestMode,
} from "../../components";
import { APP_MESSAGE_AREA, AppMessage } from "./AppMessage";
import { ENVIRONMENT } from "../../core/constants";
import { envConfig } from "../../core/config";

const Scene = ({ children, infoBorder }) => (
  <PortalBackground whiteBackgroundOnMobile={true}>
    <Header currency="AU" infoBorder={infoBorder} />

    <AppMessage area={APP_MESSAGE_AREA.PARTNER_HUB} />

    <Container maxWidth="1110">
      <Grid preset="page" rowsGap={0}>
        <Grid.Item colSpan="0-12">
          {envConfig !== ENVIRONMENT.PROD && <TestMode />}
        </Grid.Item>

        {children}
      </Grid>
    </Container>
  </PortalBackground>
);

const FullWidth = ({ children }) => (
  <Grid.Item colSpan="0-12">{children}</Grid.Item>
);

Scene.FullWidth = FullWidth;

export default Scene;
